import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { ProductInventoryTransactionsTab } from "@/screens/Inventory/subfeatures/ProductInventory/components"
import { productInventoryTransactionsSearchSchema } from "@/screens/Inventory/subfeatures/ProductInventory/schemas"

export const Route = createFileRoute("/app/inventory/products/$productId/_layout/transactions")({
  validateSearch: zodValidator(productInventoryTransactionsSearchSchema),
  component: () => <ProductInventoryTransactionsTab />,
})
